module.exports = __webpack_public_path__ + "static/media/woman-report.6e684788.png";